import { CRM_WEB_PAGES_URLS } from '../../CRM_WEB_PAGES_URLS';
import { OrganizationSettings } from '@care-portals/api-interfaces';

export const cover_health_specialists: OrganizationSettings = {
  name: 'Cover Specialists',
  fromEmail: 'help@cover.health',
  replyToEmail: 'help@cover.health',
  ecommerceEnabled: false,
  stripeEnabled: false,
  emrEnabled: true,
  conversationServiceId: '',
  appointmentconsentSection: `
    <p style="text-align: center;color: #536476;">
    By clicking on {{cta_label}} you agree to our:<br />
    <a
      href="javascript:window.open('https://cover.health/privacy-policy', 'popup', 'width=600,height=600');"
    >
        Privacy Policies
    </a>
    <br>
    <a
      href="javascript:window.open('https://cover.health/terms-conditions', 'popup', 'width=600,height=600');"
    >
    Terms & Conditions
    </a>
      </p>
    `,

  // navigation
  crmWebAppLayout: {
    title: 'Cover Specialists',
    logo: 'https://cover.health/wp-content/uploads/2020/04/cropped-cover-health-logo.png',
    emrPatientLink:
      'https://cover-health.kai-oscar.com/oscar/demographic/demographiccontrol.jsp?displaymode=edit&dboperation=search_detail&demographic_no=',
    mainMenu: [
      {
        title: 'Leads',
        link: CRM_WEB_PAGES_URLS.leads.list,
        icon: 'fa-regular fa-address-book',
        roles: ['*']
      },
      {
        title: 'Appointments',
        link: CRM_WEB_PAGES_URLS.appointments.calendar,
        icon: 'fa-regular fa-calendar-check',
        roles: ['*']
      },
      {
        title: 'Tasks',
        link: CRM_WEB_PAGES_URLS.tasks.list,
        icon: 'fa-solid fa-list-check',
        roles: ['*']
      },
      {
        title: 'Segments',
        link: CRM_WEB_PAGES_URLS.segment.list,
        icon: 'fa-solid fa-table-columns',
        roles: ['*']
      },
      {
        title: 'Admin',
        link: '',
        icon: 'fas fa-user-cog',
        roles: ['admin', 'developer', 'owner'],
        items: [
          {
            title: 'Services',
            link: CRM_WEB_PAGES_URLS.services.list,
            icon: 'fas fa-medkit'
          },
          {
            title: 'Schedules',
            link: CRM_WEB_PAGES_URLS.schedules.list,
            icon: 'fas fa-calendar'
          },
          {
            title: 'Users',
            link: CRM_WEB_PAGES_URLS.users.list,
            icon: 'fas fa-lock'
          },
          {
            title: 'Forms',
            link: CRM_WEB_PAGES_URLS.forms.list,
            icon: 'fas fa-table'
          },
          {
            title: 'Workflows',
            link: CRM_WEB_PAGES_URLS.workflows.list,
            icon: 'fas fa-code-branch'
          },
          {
            title: 'Templates',
            link: CRM_WEB_PAGES_URLS.emailTemplates.list,
            icon: 'fas fa-palette'
          },
          {
            title: 'Settings',
            link: CRM_WEB_PAGES_URLS.settings.base,
            icon: 'fa-solid fa-sliders'
          }
        ]
      }
    ]
  }
};
